import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { UserStatus as UserStatusType } from 'src/@types/user-status';

// -----------------------------------------

interface UserStatusProps {
  label: string;
  icon: React.ReactElement;
  changeStatus: (value: UserStatusType) => void;
  selectedStatus: UserStatusType;
  value: UserStatusType;
}

export default function UserStatus({
  label,
  icon,
  changeStatus,
  selectedStatus,
  value,
}: UserStatusProps) {
  const selected = selectedStatus === value;
  return (
    <MenuItem
      key={label}
      onClick={() => changeStatus(value)}
      selected={selected}
    >
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText>{label}</ListItemText>
    </MenuItem>
  );
}
